<template>
<b-container v-if="this.getEstablecimiento">
  <h1 class="text-center">Registrar Solicitud de Licencia </h1>
  <h5>{{ (this.getEstablecimiento ? this.getEstablecimiento.DisplayNivelAsignado : '') }}</h5>
  <hr>
  <b-row>
    <b-col cols="12" lg="12">
      <form-buscar-personal></form-buscar-personal>
    </b-col>
  </b-row>

  <hr/>

  <b-row  v-if="notEmptyObject(this.Personal) && notEmptyObject(this.ListaCargoPersonal)">
    <b-col cols="12">
      <b-tabs pills card>
        <b-tab title="Cargos" active >
          <b-button  variant="warning" v-b-modal.modalRegistrarDiv size="sm" class="mb-2" v-if="this.ListaCargoPersonalSeleccionado.length > 0">
            <b-icon icon="calendar-plus"></b-icon> Registrar Solicitud de Licencia
          </b-button>
          <tabla-cargo-personal :seleccionable="true"></tabla-cargo-personal>
        </b-tab>
        <b-tab title="Historial">
          <b-row>
            <b-col cols="12" lg="12">
              <tabla-historial-solicitud :personal="this.Personal" ></tabla-historial-solicitud>
            </b-col>
          </b-row>
        </b-tab>
      </b-tabs>
    </b-col>
  </b-row>

  <b-modal
    v-if="notEmptyObject(this.Personal)"
    id="modalRegistrarDiv" ref="modal"
    hide-footer
    :title="modalRegistrar.title"
    size="lg"
    :header-bg-variant="modalRegistrar.headerBackground"
    header-text-variant="light">
    <registrar-solicitud-form
      v-on:form-solicitud-close="cerrarModal($event)"
      :personal="this.Personal"
      :cargopersonal="this.ListaCargoPersonal">
    </registrar-solicitud-form>
  </b-modal>
  <b-modal id="agregarCargoMOD"
    title="Agregar Cargo"
    size="md"
    ok-title="Agregar"
    ok-variant="primary"
    cancel-title="Cancelar"
    header-bg-variant="dark"
    header-text-variant="light" centered >
      <b-container fluid>
          <b-row>
              <b-col cols="12">
                <b-list-group v-for="cargo in (listacargosagregar)" :key="cargo.Id" flush>
                    <b-list-group-item :variant="cargo.activo ? 'danger':''">
                      <b-form-checkbox v-model="cargo.activo" ></b-form-checkbox>
                      {{cargo.antiguedad}}  {{cargo.DisplayInfoCargoEstablecimiento}}</b-list-group-item>
                </b-list-group>
              </b-col>
          </b-row>
      </b-container>
  </b-modal>
</b-container>
</template>

<script>
import swalerts from "@/helpers/swalerts";
import errorhandler from "@/helpers/errorhandler";
import { mapGetters,mapActions } from 'vuex'
import axios from 'axios';
import moment from 'moment';
import qs from 'qs';
import LicenciaCargoPersonalSvc from '@/services/licenciacargopersonal'

import RegistrarSolicitudForm from './RegistrarSolicitudForm.vue'

import TablaHistorialSolicitud from '../../common/TablaHistorialSolicitud.vue'
import TablaCargoPersonal from '../../common/TablaCargoPersonal.vue'
import FormBuscarPersonal from '../../common/FormBuscarPersonal.vue';


import { createHelpers } from 'vuex-map-fields';



const { mapFields: mapSolicitudFields } = createHelpers({
  getterType: 'FormSolicitudModule/getSolicitudField',
  mutationType: 'FormSolicitudModule/updateSolicitudField',
});

const { mapFields: mapFormBuscarPersonalFields } = createHelpers({
  getterType: 'FormBuscarPersonal/getFormBuscarPersonalField',
  mutationType: 'FormBuscarPersonal/updateFormBuscarPersonalField',
});

export default {
  name: "RegistrarSolicitud",
  mixins: [errorhandler, swalerts],
  components: { RegistrarSolicitudForm, TablaHistorialSolicitud, FormBuscarPersonal, TablaCargoPersonal },
  computed: {
    ...mapGetters(['getEstablecimiento', 'isInRoleAdmin', 'isInRoleCoordinador', 'isInRoleEstablecimiento', 'isInRoleRecMedico']),
    ...mapSolicitudFields(['TipoLicencia', 'DetalleDiasLicencia', 'EstadoSolicitudMedica', 'FechaDesde', 'Observaciones', 'CantidadDias', 'ListaCargoPersonalSeleccionado' ]),
    ...mapFormBuscarPersonalFields(['Personal', 'ListaCargoPersonal', 'Dni'])
  },

  data() {
    return {
      modalRegistrar:
      {
        headerBackground:'dark',
        title: '',
        content: '',
      },
      articuloSeleccionado:null,
      solicitudseleccionada:null,
      listacargosagregar:[],
      disabled:null,
      unidadId:'',
      nivelSolicitud : '',
      infoContacto: [],
      datosDocente: [],
      arregloLicencias: [],

      status: '',
      allCargosSelected:false,
      inputDniSearch: null
    }
  },
  mounted(){
    this.ListaCargoPersonalSeleccionado = [];
  },
  methods: {
    articuloTrigger(articulo){
      console.log(articulo);
      if(articulo === 'Articulo 32'){
        console.log('mostrar formulario 32');
        this.ausenteDesdeVisible = false;
      }else{
        console.log('ocultar formulario 32');
        this.ausenteDesdeVisible = true;
      }
    },

    findLicenciaCargoPersonal() {
      return LicenciaCargoPersonalSvc.findl({
        Personal_Id: this.id,
        IncluyeCargoPersonal: true,
        IncluyeUsuarioCarga: true
      });
    },
    limpiar() {
      this.datosDocente = [];
      this.cantDiasSinTrabajar = 0;
    },
    cerrarModal(mensaje){
      if(mensaje){
        this.showSuccess(mensaje);
      }
      this.$refs.modal.hide();
    },
    obtenerFechaHasta() {
      var fechaRetornada = moment(this.txtFechaActual).add(this.txtCantidadDias, 'days').subtract(1, 'days').format();
      return fechaRetornada;
    },

    porcentajeDias() {
      return this.diasSinTrabajar;
    },
    cantDiasAnio() {
      return 365
    },



  }
}
</script>

<style >

</style>



// WEBPACK FOOTER //
// src/components/pages/solicitudes/RegistrarSolicitud.vue